module.exports = __webpack_public_path__ + "media/slot-game/breacfast-a5da7c22.svg";